module.exports = __webpack_public_path__ + "img/PE.e3d13378.svg";